<div
  class="min-h-screen p-4 md:p-8 bg-linear-to-br flex items-center justify-center from-surface-container-highest via-surface-container-high to-surface-container-lowest"
>
  <div class="text-center p-8 max-w-2xl mx-auto w-full">
    <h1 class="text-2xl md:text-6xl font-normal mb-6 leading-tight">
      {{ 'AUTH.ENTRA.title' | translate }}
    </h1>

    <p
      class="text-lg md:text-xl mb-10 font-light"
      [ngClass]="{
        'text-error': loginError || permissionsError
      }"
    >
      @if (isLoading) {
        {{ 'AUTH.ENTRA.loading' | translate }}
      } @else if (loginError) {
        {{ 'AUTH.ENTRA.login_failed' | translate }}
      } @else if (permissionsError) {
        {{ 'AUTH.ENTRA.no_permissions' | translate }}
      } @else {
        {{ 'AUTH.ENTRA.success' | translate }}
      }
    </p>

    @if (isLoading) {
      <div class="flex justify-center">
        <button matButton type="button" (click)="goToLogin()" [attr.aria-label]="'AUTH.ENTRA.cancel' | translate">
          {{ 'AUTH.ENTRA.cancel' | translate }}
        </button>
      </div>
    }

    @if (!isLoading && loginError) {
      <div class="flex justify-center gap-3">
        <button matButton type="button" (click)="goToLogin()" [attr.aria-label]="'AUTH.ENTRA.cancel' | translate">
          {{ 'AUTH.ENTRA.cancel' | translate }}
        </button>
        <button matButton="filled" type="button" (click)="retryLogin()" [attr.aria-label]="'AUTH.ENTRA.retry' | translate">
          {{ 'AUTH.ENTRA.retry' | translate }}
        </button>
      </div>
    }

    @if (!isLoading && permissionsError) {
      <div class="flex justify-center">
        <button matButton="filled" type="button" (click)="goToLogin()">
          {{ 'AUTH.ENTRA.back_home' | translate }}
        </button>
      </div>
    }

    @if (!isLoading && debugApiResponse) {
      <div class="text-left space-y-6">
        <div>
          <p class="font-semibold mb-2">Risposta API login-entra</p>
          <pre class="text-xs bg-slate-50 border border-slate-200 rounded p-4 overflow-auto whitespace-pre-wrap">{{ debugApiResponse }}</pre>
        </div>
      </div>
    }
  </div>
</div>
